import type { HTMLAttributes, ReactNode } from "react";
import type { Tone } from "../../lib/format.js";
import { cx } from "./cx.js";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: Tone;
  dot?: boolean;
  children: ReactNode;
}

export function Badge({ tone = "neutral", dot = false, className, children, ...rest }: BadgeProps) {
  return (
    <span className={cx("badge", tone !== "neutral" && `badge--${tone}`, className)} {...rest}>
      {dot ? <span className="badge__dot" aria-hidden /> : null}
      {children}
    </span>
  );
}

export interface StatusBadgeProps {
  /** Raw status key; kept in the tooltip so staff can see the exact value. */
  status: string;
  label: string;
  tone: Tone;
}

export function StatusBadge({ status, label, tone }: StatusBadgeProps) {
  return (
    <Badge tone={tone} title={status} dot>
      {label}
    </Badge>
  );
}
